import React from "react";
import {
  getDateFromTimestamp,
  determineTextColor,
} from "helpers/efficeHelpers";
import { getPersonName } from "helpers/randomHelpers";

const NewMember = ({ efficeData }) => {
  return (
    <>
      <div className="Txt-effice-left-side"></div>
      <div className="Txt-effice-middle-content-special">
        <div className={determineTextColor(efficeData)}>
          {getPersonName(
            efficeData.creator.given_name,
            efficeData.creator.family_name
          )}
          {` has joined this channel - `}
          <div className="Txt-effice-time-font">
            {getDateFromTimestamp(efficeData.created_at)}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewMember;
